$(document).ready(function () {
    const init_class = abcsetup.item && abcsetup.item.role ? abcsetup.item.role.class : '';

    if ($("#type").val() === 'otg') {
        $("#rx_item").val("Y").trigger("change");
        //$("#inners").val("Y").attr("disabled",true).trigger("change");
        //$("#inners").after('<input type="hidden" name="inners" id="inners" value="Y">');
        //disabled 12/19/2022 upon lindsays request for ticket abcs-1235 -ke
        /* $('#mat_group').val('OTG');
        $('#mat_group').attr('disabled', true).addClass('readonly');
        $('#mat_group').after('<input type="hidden" id="mat_group" name="mat_group" value="OTG">'); */
    }

    $("#medical_device").change(function() {
        var rx_item = $("#rx_item");
        var gnp = $("#gnp");
        if ($(this).val() == 'Y') {
            rx_item.val("Y").trigger("change").attr('disabled',true).addClass('readonly');
            rx_item.after('<span class="small inForm text-danger errorMsg medical_device_is_rx">If the item is a Medical Device, it must be considered an RX</span><input type="hidden" id="' + rx_item.attr('id') + '" name="' + rx_item.attr('id') + '" value="Y">');
        }
        else {
            rx_item.attr('disabled', false).removeClass('readonly');
            $("input[id='rx_item']").remove();
            $(".medical_device_is_rx").remove();

            if (!rx_item.hasClass("disabled") && gnp.val() != 'Y') {
                // if gnp=Y, then rx_item must stay disabled and unaltered
                rx_item.attr("disabled", false).parent("td").removeClass("readonly");
                $("input[id='rx_item']").remove();

                var rx_item_reset_val = abcsetup.item.rx_item
                if (rx_item_reset_val == '' && rx_item.val() != '') {
                    rx_item_reset_val = rx_item.val();
                }

                if(rx_item_reset_val) {
                    rx_item.val(rx_item_reset_val).trigger("change");
                }
            }
            $(".medical_device_is_rx").remove();

        }
    }).trigger("change");

    $("#listed_chemical").change(function() {
        if ($(this).val() != 'Y') {
            $("#listed_chemical_ingredient").val('').after('<input type="hidden" id="listed_chemical_ingredient" name="listed_chemical_ingredient" class="hidden_listed_chemical" value="">');
            $("#listed_chemical_ingredient_amount").val('').after('<input type="hidden" id="listed_chemical_ingredient_amount" name="listed_chemical_ingredient_amount" class="hidden_listed_chemical" value="">');
            $("#listed_chemical_ingredient_amount_unit").val('').after('<input type="hidden" id="listed_chemical_ingredient_amount_unit" name="listed_chemical_ingredient_amount_unit" class="hidden_listed_chemical" value="">');
            $("#listed_chemical_category").val('').after('<input type="hidden" id="listed_chemical_category" name="listed_chemical_category" class="hidden_listed_chemical" value="">');
        }
        else {
            $(".hidden_listed_chemical").remove();
        }
    }).trigger("change");


    $("#layers_pallet").bind('change keyup',function(){
        if ($.isNumeric($(this).val()) && $.isNumeric($("#cases_layers").val())) {
           $("#cases_pallet").val($(this).val() * $("#cases_layers").val());
           $("#cases_pallet").addClass('readonly').trigger("change", {revalidate: true});
        }
        else {
           $("#cases_pallet").val(0).trigger("change", {revalidate: true});
        }
    });
    $("#cases_layers").bind('change keyup',function(){
        if ($.isNumeric($(this).val()) && $.isNumeric($("#layers_pallet").val())) {
           $("#cases_pallet").val($(this).val() * $("#layers_pallet").val());
           $("#cases_pallet").addClass('readonly').trigger("change", {revalidate: true});
        }
        else {
           $("#cases_pallet").val(0).trigger("change", {revalidate: true});
        }
    });

    $("#dscsa_exempt").change(function () {
        const dscsa_exempt = $(this).val();

        if (dscsa_exempt == 'WEE') {
            $("#dscsa_exempt_reason").val("18").attr('disabled',true).addClass('readonly');
            $("#dscsa_exempt_reason").after('<input type="hidden" id="dscsa_exempt_reason" name="dscsa_exempt_reason" value="18">');
        }
        else {
            if ($("#dscsa_exempt_reason").val() == 18 ) {
                $("#dscsa_exempt_reason").val("").attr('disabled',false).removeClass('readonly');
                $("input[id='dscsa_exempt_reason']").remove();
            }
        }
    }).trigger("change");

    $("#controlled_content").change(function () {
        const controlled_content = $(this).val();

        if (controlled_content == 'N') {
            $("#controlled_substance").val("");
            $("#controlled_substance").after('<input type="hidden" id="controlled_substance" name="controlled_substance" value="">');
        }
        else {
            $("input[id='controlled_substance']").remove();
        }
    }).trigger("change");

    $("#wac_price").on("change",function(event, {initialRun = false, recalc = false} = {}) {
        if ($(this).length) {
            let caseCost = parseFloat($('#case_cost').val());
            let casePackQty = parseFloat($("#case_pack_quantity").val());
            let wacPrice = $(this).val();
            let wholesaleUnit = $("#wholesale_unit").val();
            let qtyInners = $("#quantity_inners").val();

            /**
             * Inital run is only called if user is supplier and wac is null
             */
            if (initialRun) {
                if ($('#type').val() !== 'otg') {
                    // Wholesale unit is not set for OTG items
                    switch (wholesaleUnit) {
                        case "CS":
                            if (caseCost != '' && casePackQty != '') {
                                wacPrice = (parseFloat(caseCost)/parseFloat(casePackQty)).toFixed(2);
                            }
                            break;

                        case "PK":
                            if (caseCost != '' && qtyInners != '') {
                                wacPrice = (parseFloat(caseCost)/parseFloat(qtyInners)).toFixed(2);
                            }
                            break;

                        case "EA":
                            if (caseCost != '' && casePackQty != '') {
                                wacPrice = (parseFloat(caseCost)/parseFloat(casePackQty)).toFixed(2);
                            }
                            break;
                        default:
                            wacPrice = (Math.round(parseFloat(caseCost) / parseFloat(casePackQty) * 100 ) / 100).toFixed(2);
                            break;
                    }
                } else  {
                    wacPrice = (Math.round(parseFloat(caseCost) / parseFloat(casePackQty) * 100 ) / 100).toFixed(2);
                }
            }

            /**
             * Recalc is called when case_pack_qty is updated in the UI
             */
            if (recalc) {
                wacPrice = (Math.round(parseFloat(caseCost) / parseFloat(casePackQty) * 100 ) / 100).toFixed(2);
            }

            $(this).val(wacPrice);
            // $('#wac_price_pr').val(wacPrice);
            // $('#wac_price_hawaii').val(wacPrice);

            //If a valid wac price was set above, update the case cost
            if (wacPrice && parseFloat(wacPrice) != 0) {
                // Re-calculate the Case Cost
                if (!initialRun) {
                    if ($("#type").val() !== 'otg') {
                    // Wholesale unit is not set for OTG items
                        switch (wholesaleUnit) {
                            case "CS":
                                if (wacPrice != '') {
                                    caseCost = (Math.round(parseFloat(wacPrice) * 100) / 100).toFixed(2);
                                }
                                break;

                            case "PK":
                                if (wacPrice != '' && qtyInners != '') {
                                    caseCost = (Math.round(parseFloat(wacPrice)*parseFloat(qtyInners) * 100) / 100).toFixed(2);
                                }
                                break;

                            case "EA":
                                if (wacPrice != '' && casePackQty != '') {
                                    caseCost = (Math.round(parseFloat(wacPrice)*parseFloat(casePackQty) * 100) / 100).toFixed(2);
                                }
                                break;
                            default:
                                caseCost = (Math.round(parseFloat(wacPrice) * parseFloat(casePackQty) * 100) / 100).toFixed(2);
                                break;
                        }
                    }

                    $("#case_cost").val(caseCost);
                    // $("#case_cost_pr").val(caseCost);
                    // $("#case_cost_hawaii").val(caseCost);
                }
            }

            if ($(this).hasClass('set-name')){
                if ($('input[name="wac_price"]').length){
                    $('input[name="wac_price"]').val(wacPrice);
                }
                else {
                    $("#wac_price").after("<input type='hidden' name='wac_price' value='"+wacPrice+"'/>");
                }
            }
        }
    });

    if (abcsetup.userRole.class === 'vendor' && !$('#wac_price').val()) {
        $("#wac_price").trigger("change", {initialRun: true});
    }

    $("#case_cost").on('blur', function () {
        abcsetup.front_store.form._setUomCost();
        let caseCost = parseFloat($(this).val());
        let wholesaleUnit = $("#wholesale_unit").val();
        let casePackQty = parseFloat($("#case_pack_quantity").val());
        let qtyInners = $("#quantity_inners").val();
        let wacPrice = parseFloat($("#wac_price").val());
        let wacPriceInput = $("#wac_price");

        if ($("#type").val() !== 'otg') {
            if (wholesaleUnit && wholesaleUnit != '') {
                switch (wholesaleUnit) {
                    case "CS":
                        if (caseCost != '' && casePackQty != '') {
                            wacPrice = (parseFloat(caseCost)/parseFloat(casePackQty)).toFixed(2);
                        }
                        break;

                    case "PK":
                        if (caseCost != '' && qtyInners != '') {
                            wacPrice = (parseFloat(caseCost)/parseFloat(qtyInners)).toFixed(2);
                        }
                        break;

                    case "EA":
                        if (caseCost != '' && casePackQty != '') {
                            wacPrice = (parseFloat(caseCost)/parseFloat(casePackQty)).toFixed(2);
                        }
                        break;
                }
            } else {
                wacPrice = (Math.round(parseFloat(caseCost) / parseFloat(casePackQty) * 100 ) / 100).toFixed(2);
            }

            $('#wac_price').val(wacPrice);
            // $('#wac_price_pr').val(wacPrice);
            // $('#wac_price_hawaii').val(wacPrice);
            // $('#case_cost_pr').val(parseFloat(caseCost).toFixed(2));
            // $('#case_cost_hawaii').val(parseFloat(caseCost).toFixed(2));

            if ($("#wac_price").hasClass('set-name')){
                if ($('input[name="wac_price"]').length){
                    $('input[name="wac_price"]').val(wacPrice);
                }
                else {
                    $("#wac_price").after("<input type='hidden' name='wac_price' value='"+wacPrice+"'/>");
                }
            }
        }
        else {
        // For OTG items allow the change event to recalculate the supernet price
            $("#wac_price").trigger("change");
        }

        if (wacPriceInput.val().trim() != "") {
            window.fieldValidate.resetValidation(wacPriceInput);
        }
    });

    $.each(['case', 'dozens', 'inner', 'item', 'display'], function (uom_idx, uom) {
        /*
         * Set NDC10 mask whenever the mask format changes.
         */
        $("#"+uom+"_ndc10_format").change(function() {
            var ndc10_format = $(this).val();
            var ndc10 = $("#"+uom+"_ndc_10");
            var ndc11 = $("#"+uom+"_ndc");
            if (ndc10_format && ndc10_format.length) {
                switch (ndc10_format) {
                    case "4-4-2":
                        ndc10.mask("9999-9999-99", {reverse: true});
                        break;
                    case "5-3-2":
                        ndc10.mask("99999-999-99", {reverse: true});
                        break;
                    case "5-4-1":
                        ndc10.mask("99999-9999-9", {reverse: true});
                        break;
                }
            }
            else {
                ndc10.val("").closest("tr").hide();
            }

            //if (ndc11.val().length) {
            //    ndc11.trigger("change");
            //}
        }).trigger("change", {initialRun: true});

        /*
         * Calculate the NDC11, whenever the NDC10 changes.
         */
        $("#"+uom+"_ndc_10").change(function() {
            var ndc10 = $(this).val();
            var ndc10_format = $("#"+uom+"_ndc10_format").val();
            var ndc11 = $("#"+uom+"_ndc");

            if (ndc10.length) {
                switch (ndc10_format) {
                    case "4-4-2":
                        ndc11.val("0" + ndc10.replace(/-/g, ""));
                        break;
                    case "5-3-2":
                        ndc11.val(
                            ndc10.substr(0, 5) + "0" + ndc10.substr(6, 3) + ndc10.substr(10, 2)
                        );
                        break;
                    case "5-4-1":
                        ndc11.val(
                            ndc10.substr(0, 5) + ndc10.substr(6, 4) + "0" + ndc10.substr(11, 1)
                        );
                        break;
                }
            }
        }).trigger("change", {initialRun: true});
    });

    new ArticleIdentifiers()
        .bindChange()
        .bindToShippingMethodChanges()
        .bindToPoIdentifierChanges();

    $("#blood_product").change(function() {
        var tmpID = abcsetup.randomString();
        var flu_product = $("#flu_product");
        var vac_product = $("#vaccine_product");
        var oral_med_product = $("#oral_med_product");

        if ($(this).val() == 'Y') {
            flu_product.val("N").attr('disabled',true).addClass('readonly');
            flu_product.after('<input type="hidden" id="' + flu_product.attr('id') + '" name="' + flu_product.attr('id') + '" value="N">');

            vac_product.val("N").attr('disabled',true).addClass('readonly');
            vac_product.after('<input type="hidden" id="' + vac_product.attr('id') + '" name="' + vac_product.attr('id') + '" value="N">');

            oral_med_product.val("N").attr('disabled',true).addClass('readonly');
            oral_med_product.after('<input type="hidden" id="' + oral_med_product.attr('id') + '" name="' + oral_med_product.attr('id') + '" value="N">');
        }
        else {
            if (flu_product.val() != 'Y' && vac_product.val() != 'Y' && oral_med_product.val() != 'Y') {
                flu_product.attr('disabled',false).removeClass('readonly');
                $("input[id='flu_product']").remove();
                vac_product.attr('disabled',false).removeClass('readonly');
                $("input[id='vaccine_product']").remove();
                oral_med_product.attr('disabled',false).removeClass('readonly');
                $("input[id='oral_med_product']").remove();
            }
        }
    }).trigger("change");

    $("#flu_product").change(function() {
        var tmpID = abcsetup.randomString();
        var blood_product = $("#blood_product");
        var vac_product = $("#vaccine_product");
        var oral_med_product = $("#oral_med_product");

        if ($(this).val() == 'Y') {
            blood_product.val("N").attr('disabled',true).addClass('readonly');
            blood_product.after('<input type="hidden" id="' + blood_product.attr('id') + '" name="' + blood_product.attr('id') + '" value="N">');

            vac_product.val("N").attr('disabled',true).addClass('readonly');
            vac_product.after('<input type="hidden" id="' + vac_product.attr('id') + '" name="' + vac_product.attr('id') + '" value="N">');

            oral_med_product.val("N").attr('disabled',true).addClass('readonly');
            oral_med_product.after('<input type="hidden" id="' + oral_med_product.attr('id') + '" name="' + oral_med_product.attr('id') + '"value="N">');
        }
        else {
            if (blood_product.val() != 'Y' && vac_product.val() != 'Y' && oral_med_product.val() != 'Y') {
                blood_product.attr('disabled',false).removeClass('readonly');
                $("input[id='blood_product']").remove();
                vac_product.attr('disabled',false).removeClass('readonly');
                $("input[id='vaccine_product']").remove();
                oral_med_product.attr('disabled',false).removeClass('readonly');
                $("input[id='oral_med_product']").remove();
            }
        }
    }).trigger("change");

    $("#vaccine_product").change(function() {
        var tmpID = abcsetup.randomString();
        var blood_product = $("#blood_product");
        var flu_product = $("#flu_product");
        var oral_med_product = $("#oral_med_product");
        var rx_group = $("#rx_group");

        if ($(this).val() == 'Y') {
            blood_product.val("N").attr('disabled',true).addClass('readonly');
            blood_product.after('<input type="hidden" id="' + blood_product.attr('id') + '" name="' + blood_product.attr('id') + '" value="N">');

            flu_product.val("N").attr('disabled',true).addClass('readonly');
            flu_product.after('<input type="hidden" id="' + flu_product.attr('id') + '" name="' + flu_product.attr('id') + '" value="N">');

            oral_med_product.val("N").attr('disabled',true).addClass('readonly');
            oral_med_product.after('<input type="hidden" id="' + oral_med_product.attr('id') + '" name="' + oral_med_product.attr('id') + '" value="N">');

            rx_group.val("03").attr("disabled",true).addClass("readonly");
            rx_group.after('<input type="hidden" name="rx_group" value="03">');
        } else {
            rx_group.attr("disabled",false).removeClass("readonly");
            $("input[name='rx_group']").remove();
            if (blood_product.val() != 'Y' && flu_product.val() != 'Y' && oral_med_product.val() != 'Y') {
                blood_product.attr('disabled',false).removeClass('readonly');
                $("input[id='blood_product']").remove();
                flu_product.attr('disabled',false).removeClass('readonly');
                $("input[id='flu_product']").remove();
                oral_med_product.attr('disabled',false).removeClass('readonly');
                $("input[id='oral_med_product']").remove();
            }
        }
    }).trigger("change");

    $("#oral_med_product").change(function() {
        var tmpID = abcsetup.randomString();
        var blood_product = $("#blood_product");
        var flu_product = $("#flu_product");
        var vac_product = $("#vaccine_product");
        var product_type = $("#product_type");

        if ($(this).val() == 'Y') {
            blood_product.val("N").attr('disabled',true).addClass('readonly');
            blood_product.after('<input type="hidden" id="' + blood_product.attr('id') + '" name="' + blood_product.attr('id') + '" value="N">');

            flu_product.val("N").attr('disabled',true).addClass('readonly');
            flu_product.after('<input type="hidden" id="' + flu_product.attr('id') + '" name="' + flu_product.attr('id') + '" value="N">');

            vac_product.val("N").attr('disabled',true).addClass('readonly');
            vac_product.after('<input type="hidden" id="' + vac_product.attr('id') + '" name="' + vac_product.attr('id') + '" value="N">');

            // product_type.val("OMD");//.attr("disabled",true).addClass("readonly");
        }
        else {
            if (blood_product.val() != 'Y' && flu_product.val() != 'Y' && vac_product.val() != 'Y') {
                blood_product.attr('disabled',false).removeClass('readonly');
                $("input[id='blood_product']").remove();
                vac_product.attr('disabled',false).removeClass('readonly');
                $("input[id='vaccine_product']").remove();
                flu_product.attr('disabled',false).removeClass('readonly');
                $("input[id='flu_product']").remove();
            }
        }
    }).trigger("change");

    $("#form").change(function() {
        var form_val = $(this).val();
        var oral_med_form = [
            "CAP",
            "CPL",
            "CHW",
            "CTB",
            "CRY",
            "ELX",
            "EXP",
            "GMY",
            "GCP",
            "GTB",
            "GRN",
            "GUM",
            "INH",
            "LCP",
            "LGL",
            "LOZ",
            "ORS",
            "PUD",
            "SYR",
            "SGC",
            "SGT",
            "TAB",
            "WAF"];

        if (oral_med_form.indexOf(form_val) > -1) {
            $("#oral_med_product").val("Y").trigger("change").addClass("readonly").attr('disabled',true);
            $("#oral_med_product").after('<input type="hidden" id="oral_med_product" name="oral_med_product" value="Y">');
        }
        else {
            $("#oral_med_product").val("").trigger("change").removeClass("readonly").attr('disabled',false);
            $("input[id='oral_med_product']").remove();
        }
    }).trigger("change");

    /* $(".product_type").change(function() {
        var product_type = $("#product_type");
        var prod_type_obj = {};

        if ($(this).val() == 'Y') {
           var type = $(this).attr("id");
           type_part = type.match(/(\w+)_product/)[1];
           console.log("abc_item/product_type: "+type_part);
            $.ajax({
                type: "POST",
                url: "/api/abc_item/product_type",
                cache: false,
                dataType: 'json',
                data: {type: type_part},
                success: function(result) {
                    console.log("abc_item/product_type->"+JSON.stringify(result,{},4));
                    // if (type_part != 'oral_med') {
                        product_type.empty().append($("<option></option>").attr("value","").text("-select-"));
                    // }
                    // else {
                        // product_type.empty();
                    // }

                    if (!$.isEmptyObject(result)) {
                        prod_type_obj = result;
                        prod_type_obj.forEach(function(prod_type) {
                            product_type.append($("<option></option>").attr("value",prod_type.id).text(prod_type.name));
                        });

                        if (abcsetup.item != undefined) {
                            if (abcsetup.item && product_type.find("option[value='"+abcsetup.item.product_type+"']").length) {
                                product_type.val(abcsetup.item.product_type);
                            }
                        }
                    }
                }
            });
        }
    }).trigger("change"); */

    $("#bracket_pricing").change(function() {
        var break_pricing = $("#break_pricing");

        if ($(this).val() == 'Y') {
            break_pricing.val("N").attr('disabled',true).removeClass('invalid').addClass('readonly');
            break_pricing.after('<input type="hidden" id="' + break_pricing.attr('id') + '" name="' + break_pricing.attr('id') + '" value="N">');
            break_pricing.closest("div.form-group").find(".errorMsg").remove();
        }
        else {
            break_pricing.attr('disabled',false).removeClass('readonly');
            $("input[id='break_pricing']").remove();
        }
    }).trigger("change");

    $("#break_pricing").change(function() {
        var bracket_pricing = $("#bracket_pricing");

        if ($(this).val() == 'Y') {
            bracket_pricing.val("N").attr('disabled',true).removeClass('invalid').addClass('readonly');
            bracket_pricing.after('<input type="hidden" id="' + bracket_pricing.attr('id') + '" name="' + bracket_pricing.attr('id') + '" value="N">');
            bracket_pricing.closest("div.form-group").find(".errorMsg").remove();

            $("input[name='bracket_break_pricing[break][1][min_price]']").val(0);
            $('input[name="bracket_break_pricing[break][1][max_price]"]').val(0);
            $("#bracket_pricing_type").attr('disabled',true);
            $("#break_row1").before('<input type="hidden" id="bracket_pricing_type" name="bracket_pricing_type" value="break">');
            abcsetup.front_store.form._setUomCost();
        }
        else {
            bracket_pricing.attr('disabled',false).removeClass('readonly');
            $("input[id='bracket_pricing']").remove();
            $("#bracket_pricing_type").attr('disabled',false);
            $("input[id='bracket_pricing_type']").remove();
        }
    }).trigger("change");

    $("#bracket_pricing_type").change(function() {
        $('input[name="bracket_break_pricing[' + $(this).val() + '][1][min_price]"]').val(0);
        $('input[name="bracket_break_pricing[' + $(this).val() + '][1][max_price]"]').val(0);
        abcsetup.front_store.form._setUomCost();
    }).trigger("change");

    $("#restricted_limited_distribution").change(function() {
        if ($(this).val() != 'Y') {
            $("#qualifier_code").val("");
        }
    }).trigger("change");

    $("#pr_distribution_only").change(function() {
        var restricted_limited_distribution_select = $("#restricted_limited_distribution");
        var restriction_explanation = $("#restriction_explanation");
        var drop_ship_warehouse_select = $("#drop_ship_warehouse");
        var qualifier_code_select = $("#qualifier_code");
        var ship_info_select = $("#ship_info");

        if ($("#pr_distribution_only").val() == 'Y') {
            abcsetup.alerts.show("Warning: Puerto Rico Distribution Only","By selecting Yes, you are indicating that this item will <font size='4' style='bold' color='#F03200'>ONLY</font> be distributed in Puerto Rico, and <font size='4' style='bold' color='#F03200'>NOT</font> in the mainland USA.  If you want the item distributed in both Puerto Rico and the mainland USA, you must select No in this field.");

            restricted_limited_distribution_select.val("Y").trigger("change");
            restricted_limited_distribution_select.attr("disabled",true).addClass("readonly");
            restricted_limited_distribution_select.after('<input type="hidden" id="restricted_limited_distribution" value="Y">');
            restriction_explanation.val("Puerto Rico Only").attr("readonly",true).addClass("readonly");

            qualifier_code_select.val("JMB").attr("disabled",true).addClass("readonly");
            qualifier_code_select.after('<input type="hidden" id="qualifier_code" value="JMB">');

            drop_ship_warehouse_select.val("HAWA").trigger("change");
            drop_ship_warehouse_select.attr("disabled",true).addClass("readonly");
            drop_ship_warehouse_select.after('<input type="hidden" id="drop_ship_warehouse" name="drop_ship_warehouse" value="HAWA">');

            ship_info_select.val("div").trigger("change");
            ship_info_select.attr("disabled",true).addClass("readonly");
            ship_info_select.after('<input type="hidden" id="ship_info" value="div">');
            // Refresh the shuttlebox
            var select_right =  abcsetup.form_manager.form.find(':input[name="divisions[]"]');
            var this_shuttlebox = select_right.closest("div.shuttlebox");
            var select_left = this_shuttlebox.find("select.shuttlebox-left");
            var sel_val = ['003'];

            select_right.find("option").remove().appendTo(select_left);
            $.each(sel_val, function( index, value ) {
                if (value != '') {
                    select_right.append(select_left.find("option[value="+value+"]").prop('selected','selected'));
                    select_left.find("option[value="+value+"]").remove();
                }
            });
            select_right.trigger("change");
            select_right.attr("disabled", true).addClass('readonly');
            select_left.attr("disabled", true).addClass('readonly');
            this_shuttlebox.find('.shuttlebox-add').attr('disabled',true);
            this_shuttlebox.find('.shuttlebox-remove').attr('disabled',true);
            $("input[id='divisions']").remove();
            select_right.after('<input type="hidden" id="divisions" name="divisions[]" value="003">');

        }
        else {
            if (!restricted_limited_distribution_select.hasClass("disabled")) {
                restricted_limited_distribution_select.attr('disabled',false).removeClass('readonly');
                restricted_limited_distribution_select.val(abcsetup.item.restricted_limited_distribution).trigger("change");
                $("input[id='restricted_limited_distribution']").remove();
            }
            if (!restriction_explanation.hasClass("disabled")) {
                // modified because persisted data is getting removed from that field upon rendering
                // see ABCS-749 comments, around 3:24pm from Troy Knox
                restriction_explanation.attr("readonly",false).removeClass("readonly");

                var restriction_explanation_reset_val = abcsetup.item.restriction_explanation;
                if (restriction_explanation_reset_val && restriction_explanation_reset_val == "Puerto Rico Only") {
                    restriction_explanation_reset_val = "";
                }
                restriction_explanation.val(restriction_explanation_reset_val).trigger("change");
            }

            if (!qualifier_code_select.hasClass("disabled")) {
                qualifier_code_select.attr('disabled',false).removeClass('readonly');
                $("input[id='qualifier_code']").remove();
                var qualifier_code_reset_val = abcsetup.item.qualifier_code;
                if (qualifier_code_reset_val && qualifier_code_reset_val == "JMB") {
                    qualifier_code_reset_val = "";
                }
                qualifier_code_select.val(qualifier_code_reset_val).trigger("change");
            }

            if (!drop_ship_warehouse_select.hasClass("disabled")) {
                drop_ship_warehouse_select.attr('disabled',false).removeClass('readonly');
                $("input[id='drop_ship_warehouse_select']").remove();
                drop_ship_warehouse_select.val(abcsetup.item.drop_ship_warehouse).trigger("change");
            }

            if (!ship_info_select.hasClass("disabled")) {
                ship_info_select.attr("disabled",false).removeClass("readonly");
                $("input[id='ship_info']").remove();
                ship_info_select.val(abcsetup.item.ship_info).trigger("change");
                // Refresh the shuttlebox
                var select_right =  abcsetup.form_manager.form.find(':input[name="divisions[]"]');
                var this_shuttlebox = select_right.closest("div.shuttlebox");
                var select_left = this_shuttlebox.find("select.shuttlebox-left");
                var sel_val = abcsetup.item.divisions;

                select_right.find("option").remove().appendTo(select_left);
                $.each(sel_val, function( index, option ) {
                    if (option.id != '' && option.id != "003") {
                        select_right.append(select_left.find("option[value="+option.id+"]").prop('selected','selected'));
                        select_left.find("option[value="+option.id+"]").remove();
                    }
                });

                select_right.attr("disabled", false).removeClass('readonly');
                select_left.attr("disabled", false).removeClass('readonly');
                this_shuttlebox.find('.shuttlebox-add').attr('disabled',false);
                this_shuttlebox.find('.shuttlebox-remove').attr('disabled',false);
                select_right.trigger("change");
            }
        }

        //toggle_submit_item_button();
     }).trigger("change", {initialRun: true});;


    $("#eligible_sale_pr").change(function() {
        var eligible_sale_pr = $(this).val();
        if (eligible_sale_pr === "Y") {
            //$('button#pr_registration_doc').addClass('required btn-danger');
        }
        else if (eligible_sale_pr === "in_process") {
            if (abcsetup.userRole.class === 'vendor' || abcsetup.userRole.class === 'rx_vendor') {
                abcsetup.alerts.show("Warning: Puerto Rico Distribution: In Process", "By selecting 'In Process', you are indicating that your company has initiated registering this item for sale in Puerto Rico, but have not yet received the registration documentation from the Puerto Rico Department of Health. <br><br><font style='bold' color='#F03200'>YOU WILL NEED TO SUBMIT THE REGISTRATION DOCUMENT AS SOON AS YOU OBTAIN IT.</font>");
            }
            //$('button#pr_registration_doc').removeClass('required btn-danger');
        }
        else {
            //$('button#pr_registration_doc').removeClass('required btn-danger');
        }
    }).trigger("change", {initialRun: true});

    $("#private_label").change(function() {
        var private_label_select = $("#private_label");
        var gnp_select = $("#gnp");
        var pr_only_select = $("#pr_distribution_only");
        var label_item = $("#label_item");
        var restricted_limited_distribution_select = $("#restricted_limited_distribution");
        var $category_manager_select = $("#category_manager");

        const new_category_manager_value = '6091';

        if (private_label_select.val() == "Y") {
            updateCategoryManager($category_manager_select);
            gnp_select.val("N").attr('disabled',true).addClass('readonly');
            gnp_select.after('<input type="hidden" id="' + gnp_select.attr('id') + '" name="' + gnp_select.attr('id') + '" value="N">');
            pr_only_select.val("N").attr('disabled',true).addClass('readonly');
            pr_only_select.after('<input type="hidden" id="' + pr_only_select.attr('id') + '" name="' + pr_only_select.attr('id') + '" value="N">');
            restricted_limited_distribution_select.val("Y");
            restricted_limited_distribution_select.trigger("change");
            restricted_limited_distribution_select.attr("disabled",true).addClass("readonly");
            restricted_limited_distribution_select.after('<input type="hidden" id="' + restricted_limited_distribution_select.attr('id') + '" name="' + restricted_limited_distribution_select.attr('id') + '" value="Y">');
        }
        else {
            $('.temp-submission-cm-override').remove();
            if ($category_manager_select.val() === new_category_manager_value) {

                var $private_label_option = $category_manager_select.find("option[value='" + new_category_manager_value + "']");
                if ($private_label_option.length > 0) {
                    $private_label_option.remove();
                }
            }

            if (gnp_select.val() == 'Y') {
                $category_manager_select.prop("disabled", true);
                $category_manager_select.trigger('change');
            }
            else {
                $category_manager_select.prop("disabled", false);
            }

            gnp_select.attr('disabled',false).removeClass('readonly');
            $("input[id='gnp']").remove();
            pr_only_select.attr('disabled',false).removeClass('readonly');
            $("input[id='pr_distribution_only']").remove(); // remove hidden input inserted above
            if (pr_only_select.val() != "Y" && (!label_item.length || (label_item.length && label_item.val() != "Y"))) {
                var restricted_limited_distribution_val = '';
                if (abcsetup.item != undefined) {
                    restricted_limited_distribution_val = abcsetup.item.restricted_limited_distribution;
                }
                restricted_limited_distribution_select.val(restricted_limited_distribution_val).attr("disabled",false).removeClass("readonly");
                restricted_limited_distribution_select.trigger("change");
                $("input[id='restricted_limited_distribution']").remove();
            }
        }
        //toggle_submit_item_button();
    }).trigger("change", {initialRun: true});

     $("#gnp").change(function() {
        var private_label_select = $("#private_label");
        var gnp_select = $("#gnp");
        var pr_only_select = $("#pr_distribution_only");
        var rx_item = $("select[name='rx_item']");
        var medical_device = $("select[name='medical_device']");
        var $category_manager_select = $("#category_manager");

        const new_category_manager_value = '6091';

        if (gnp_select.val() == "Y") {
            updateCategoryManager($category_manager_select);
            //$(".inner_product_code").closest("tr").hide();
            $("#pallet_gtin").closest("tr").hide();
            //$("td.front_store_item\\[inner_ndc_instructions\\]").closest("tr").hide();
            //$("#sell_sheet").removeClass("required").hide();
            //$("#flat_product_bar_code_image").removeClass("required").hide();
            $("button#flat_product_bar_code_image").removeClass("required btn-danger").addClass('btn-optional');
            private_label_select.val("N").attr('disabled',true).addClass('readonly');
            private_label_select.after('<input type="hidden" id="' + private_label_select.attr('id') + '" name="' + private_label_select.attr('id') + '" value="N">');
            pr_only_select.val("N").attr('disabled',true).addClass('readonly');
            pr_only_select.after('<input type="hidden" id="' + pr_only_select.attr('id') + '" name="' + pr_only_select.attr('id') + '" value="N">');

            if ($("#type").val() !== 'otg') {

                rx_item.val("N").trigger("change").attr("disabled",true).addClass("readonly");
                // first remove the hidden field which may have been added by the change event on medical_device
                $("input[id='rx_item']").remove();
                rx_item.after('<input type="hidden" id="' + rx_item.attr('id') + '" name="' + rx_item.attr('id') + '" value="N">');
                // medical device must be set to N

                medical_device.val("N").attr("disabled",true).addClass("readonly");
                medical_device.after('<input type="hidden" id="' + medical_device.attr('id') + '" name="' + medical_device.attr('id') + '" value="N">');
            }

        }
        else {
            $('.temp-submission-cm-override').remove();
            $category_select = $("#category");
            if ($category_manager_select.val() === new_category_manager_value) {

                var $private_label_option = $category_manager_select.find("option[value='" + new_category_manager_value + "']");
                if ($private_label_option.length > 0) {
                    $private_label_option.remove();
                }
            }

            if (private_label_select.val() == "Y") {
                $category_manager_select.prop("disabled", true);
                $category_manager_select.trigger('change');
            }
            else {
                $category_manager_select.prop("disabled", false);
            }
            
            private_label_select.attr("disabled",false).removeClass("readonly");
            $("input[id='private_label']").remove(); // remove hidden input inserted above
            pr_only_select.attr("disabled",false).removeClass("readonly");
            $("input[id='pr_distribution_only']").remove(); // remove hidden input inserted above
            // if ($("#inners").val() == "Y") {
            //    $(".inner_product_code").closest("tr").show();
            //    $("td.front_store_item\\[inner_ndc_instructions\\]").closest("tr").show();
            // }
            $("#pallet_gtin").closest("tr").show();
            // FIXME: these docs may not necessarily be required - need to store this state prior to this change
            // $("#sell_sheet").addClass("required").show();
            // if (SESSION_AUTH_USER.role.class != 'category_analyst') {
            //    $("#flat_product_bar_code_image").addClass("required").show();
            // }
            // else {
            //    $("#flat_product_bar_code_image").removeClass("required").show();
            // }
            $("button#flat_product_bar_code_image").removeClass('btn-optional').addClass("required btn-danger");
            $("#nbe_item").val("");
            $("#compare_to").val("");
            $("#compare_to_pack_count").val("");
            if (!rx_item.hasClass("disabled") && medical_device.val() != 'Y') {
                if ($("#type").val() !== 'otg') {
                    rx_item.attr("disabled",false).removeClass("readonly");
                    $("input[id='rx_item']").remove();
                }
            }
            if (!medical_device.hasClass("disabled")) {
                medical_device.attr("disabled",false).removeClass("readonly");
                $("input[id='medical_device']").remove();
            }
            if (!$(this).hasClass("disabled")) {
                $("select[name='front_store_item[private_label]']").trigger('change');
            }
        }
        //toggle_submit_item_button();
    }).trigger("change", {initialRun: true});

    $(function() {
        if ($("#eligible_sale_pr").length > 0 && $("#eligible_sale_pr").val() != "") {
            if (abcsetup.item.eligible_sale_pr != $("#eligible_sale_pr").val()) {
                $("#eligible_sale_pr").trigger("change");
            }
        }
        else {
            //$('button#pr_registration_doc').removeClass('required btn-danger');
        }
        if ($("#pr_distribution_only").val() != "") {
            if (abcsetup.item.pr_distribution_only != $("#pr_distribution_only").val()) {
                $("#pr_distribution_only").trigger("change");
            }
        }
        else {
            //$('button#pr_registration_doc').removeClass('required btn-danger');
        }
    });

    var nbe_sap_num_input = $("#nbe_sap_num");
    var nbe_upc_code_input = $("#nbe_upc_code");
    var nbe_item_descr_input = $("#nbe_item_descr");
    nbe_sap_num_input.change(function() {
        if (nbe_sap_num_input.val().length == 8) {
            // nbe_upc_code_input.attr("readonly",true);
            nbe_item_descr_input.attr("readonly",true);
        }
        else {
            nbe_upc_code_input.attr("readonly",false);
            nbe_item_descr_input.attr("readonly",false);
        }
    });
    nbe_upc_code_input.change(function() {
        if (nbe_upc_code_input.val().length == 12 && !nbe_upc_code_input.is(":disabled")) {
            // nbe_sap_num_input.attr("readonly",true);
            nbe_item_descr_input.attr("readonly",true);
        }
        else {
            nbe_sap_num_input.attr("readonly",false);
            nbe_item_descr_input.attr("readonly",false);
        }
    });

    $('#shipping_method, #po_id').on('change', function () {
        const shippingMethod = $(this).val();
        const poId = $("select[name='po_id']").val();

        if (shippingMethod !== "CS" || !poId.startsWith("CS")) {
            window.fieldValidate.resetValidation($('#case_pack_quantity'));
        }
    });

    $("#case_pack_quantity").on('change keyup', function () {
        let casePackQtyInput = $("input[name='case_pack_quantity']");
        let wholesaleUnit = $("#wholesale_unit").val();

        if (casePackQtyInput.val() == '') {
            return
        }

        if (wholesaleUnit === "CS" && casePackQtyInput.val() > 1) {
            const message = 'Shipping Unit of Measure is set to case so Case Quantity must be set to 1.  Please change the Unit of Measure before increasing Case Quantity.';
            const validationTag = 'shipping-method-case';

            window.fieldValidate.overwriteMessageFromSameTag(casePackQtyInput, message, validationTag, true);
            casePackQtyInput.val('');
            return
        }

        let qtyInners = updateQuantityInners();
        let caseCost = parseFloat($("#case_cost").val());
        let innerPackQty = parseFloat($("#inner_pack_quantity").val());
        let casePackQty = parseFloat($("#case_pack_quantity").val());
        let caseCostPR = parseFloat($("#case_cost_pr").val());
        let caseCostHW = parseFloat($("#case_cost_hawaii").val());
        let wacPrice = parseFloat($('#wac_price').val());
        let wacPricePr = parseFloat($('#wac_price_pr').val());
        let wacPriceHw = parseFloat($('#wac_price_hawaii').val());

        if ($("#type").val() !== 'otg') {
            if (wholesaleUnit === "EA") {
                if (casePackQty && !isNaN(caseCost)) {
                    wacPrice = Math.round((caseCost / casePackQty) * 100.0) / 100.0;
                }

                if (casePackQty && !isNaN(caseCostPR)) {
                    wacPricePr = Math.round((caseCostPR / casePackQty) * 100.0) / 100.0;
                }

                if (casePackQty && !isNaN(caseCostHW)) {
                    wacPriceHw = Math.round((caseCostHW / casePackQty) * 100.0) / 100.0;
                }
            }

            if (wholesaleUnit === "PK" && casePackQty && innerPackQty) {
                if (qtyInners && !isNaN(caseCost)) {
                    wacPrice = Math.round((caseCost / qtyInners) * 100.0) / 100.0;
                }

                if (qtyInners && !isNaN(caseCostPR)) {
                    wacPricePr = Math.round((caseCostPR / qtyInners) * 100.0) / 100.0;
                }

                if (qtyInners && !isNaN(caseCostHW)) {
                    wacPriceHw = Math.round((caseCostHW / qtyInners) * 100.0) / 100.0;
                }
            }

            // abcsetup.front_store.form._setUomCost();
            if (abcsetup.userRole.class !== 'vendor') {
                wacPrice = $("#wac_price").val();
                if (wholesaleUnit === "CS"){
                    // TODO It's generally best to do multiplication and division with a library like bignumber.js instead of in native JS.
                    wacPrice = Math.round(parseFloat(caseCost) / parseFloat(casePackQty) * 100 ) / 100;
                }

                $("#wac_price").val(wacPrice);
            }

            $('#wac_price').val(wacPrice);
            $('#wac_price_pr').val(wacPricePr);
            $('#wac_price_hawaii').val(wacPriceHw);
            $("#wac_price").trigger("change", {recalc: true});
            // $("#wac_price_pr").trigger("change", {recalc: true});
            // $("#wac_price_hawaii").trigger("change", {recalc: true});

            if ($("#wac_price").hasClass('set-name')){
                if ($('input[name="wac_price"]').length){
                    $('input[name="wac_price"]').val(wacPrice);
                }
                else {
                    $("#wac_price").after("<input type='hidden' name='wac_price' value='"+wacPrice+"'/>");
                }
            }
        }
        else {
        // For OTG items allow the change event to recalculate the supernet price
            $("#wac_price").trigger("change", {recalc: true});
        }
    });

    $("#inners").on('change', function () {
        if ($(this).val()=='N') {
            $("#inner_height").val("");
            $("#inner_width").val("");
            $("#inner_depth").val("");
            $("#inner_weight").val("");
            $("#inner_pack_quantity").val("");
            $("#qty_inners").val("");
            $("#inner_ean").val("");
            $("#inner_gtin").val("");
            $("#inner_mgf").val("");
            $("#inner_hibcc").val("");
            $("#inner_hri").val("");
            $("#inner_ndc10_format").val("");
            $("#inner_ndc_10").val("");
            $("#inner_ndc").val("");
            $("#inner_upc").val("");
            $("#inner_vc").val("");
        }
        else {
            var gnp = $("#gnp").val();
            if (gnp == 'N') {
                $('#inner_ean').closest('div.form-group').show();
                $('#inner_ean').show();
                $('#inner_gtin').closest('div.form-group').show();
                $('#inner_gtin').show();
                $('#inner_hibcc').closest('div.form-group').show();
                $('#inner_hibcc').show();
                $('#inner_hri').closest('div.form-group').show();
                $('#inner_hri').show();
                $('#inner_ndc10_format').closest('div.form-group').show();
                $('#inner_ndc10_format').show();
                $('#inner_upc').closest('div.form-group').show();
                $('#inner_upc').show();
                $('#inner_vc').closest('div.form-group').show();
                $('#inner_vc').show();
            }
        }
    }).trigger("change", {initialRun: true});

    $("#shipping_method").on('change', function () {
        if ($(this).val()=='DZ') {
            var gnp = $("#gnp").val();
            if (gnp != 'Y') {
                $('#dozens_ean').closest('div.form-group').show();
                $('#dozens_ean').show();
                $('#dozens_gtin').closest('div.form-group').show();
                $('#dozens_gtin').show();
                $('#dozens_hibcc').closest('div.form-group').show();
                $('#dozens_hibcc').show();
                $('#dozens_hri').closest('div.form-group').show();
                $('#dozens_hri').show();
                $('#dozens_ndc10_format').closest('div.form-group').show();
                $('#dozens_ndc10_format').show();
                $('#dozens_upc').closest('div.form-group').show();
                $('#dozens_upc').show();
                $('#dozens_vc').closest('div.form-group').show();
                $('#dozens_vc').show();
            }
        }
    }).trigger("change", {initialRun: true});

    $("#inner_pack_quantity").on('change keyup', function () {
        const qtyInners = updateQuantityInners();

        if ($("#type").val() !== 'otg') {
            const innerPackQty = parseFloat($("#inner_pack_quantity").val());
            const casePackQty = parseFloat($("#case_pack_quantity").val());
            const caseCost = parseFloat($("#case_cost").val());
            const caseCostPR = parseFloat($("#case_cost_pr").val());
            const caseCostHW = parseFloat($("#case_cost_hawaii").val());
            const wholesaleUnit = $("#wholesale_unit").val();

            if (wholesaleUnit === "PK" && casePackQty && innerPackQty) {
                if (qtyInners && !isNaN(caseCost)) {
                    // TODO It's generally best to do multiplication and division with a library like bignumber.js instead of in native JS.
                    const wacPrice = (Math.round((caseCost / qtyInners) * 100.0) / 100.0).toFixed(2);
                    $("#wac_price").val(wacPrice);
                }

                if (qtyInners && !isNaN(caseCostPR)) {
                    // TODO It's generally best to do multiplication and division with a library like bignumber.js instead of in native JS.
                    const wacPricePR = (Math.round((caseCostPR / qtyInners) * 100.0) / 100.0).toFixed(2);
                    $("#wac_price_pr").val(wacPricePR);
                }

                if (qtyInners && !isNaN(caseCostHW)) {
                    // TODO It's generally best to do multiplication and division with a library like bignumber.js instead of in native JS.
                    const wacPriceHW = (Math.round((caseCostHW / qtyInners) * 100.0) / 100.0).toFixed(2);
                    $("#wac_price_hawaii").val(wacPriceHW);
                }
            }
        }
        abcsetup.front_store.form._setUomCost();
    }).trigger("change", {initialRun: true});

    $("#wholesale_unit").on('change keyup', function () {
        if ($("#type").val() !== 'otg') {
            const caseCost = parseFloat($("#case_cost").val());
            const caseCostPR = parseFloat($("#case_cost_pr").val());
            const caseCostHW = parseFloat($("#case_cost_hawaii").val());
            const wholesaleUnit = $("#wholesale_unit").val();
            const innerPackQty = parseFloat($("#inner_pack_quantity").val());
            const qtyInners = parseFloat($("#quantity_inners").val());
            let casePackQty = parseFloat($("#case_pack_quantity").val());
            let wacPrice = parseFloat($("#wac_price").val());
            let wacPricePR = parseFloat($("#wac_price_pr").val());
            let wacPriceHW = parseFloat($("#wac_price_hawaii").val());

            if (wholesaleUnit != '') {

                switch (wholesaleUnit) {
                    case "CS":
                        abcsetup.alerts.confirm("Warning", "When Unit of Measure and Wholesale Unit are both Cases (CS/CS), the Case Pack Quantity MUST by 1.  Click OK to adjust Case Pack Qty to 1.", (resp) => {
                            if (resp) {

                                $("select[name='inners']").val('N').trigger('change');
                                $("input[name='case_pack_quantity']").val(1).trigger('change');

                                if (caseCost != '') {
                                    wacPrice = (Math.round(parseFloat(caseCost) * 100) / 100).toFixed(2);
                                }
                                if (caseCostPR != '') {
                                    wacPricePR = (Math.round(parseFloat(caseCostPR) * 100) / 100).toFixed(2);
                                }
                                if (caseCostHW != '') {
                                    wacPriceHW = (Math.round(parseFloat(caseCostHW) * 100) / 100).toFixed(2);
                                }
                            } else {
                                $("#wholesale_unit").val('').trigger('change');
                                return;
                            }
                        });
                        break;

                    case "PK":
                        if (qtyInners && !isNaN(caseCost)) {
                            wacPrice = (Math.round(parseFloat(caseCost)/parseFloat(qtyInners) * 100) / 100).toFixed(2);
                        }
                        if (qtyInners && !isNaN(caseCostPR)) {
                            wacPricePR = (Math.round(parseFloat(caseCostPR)/parseFloat(qtyInners) * 100) / 100).toFixed(2);
                        }
                        if (qtyInners && !isNaN(caseCostHW)) {
                            wacPriceHW = (Math.round(parseFloat(caseCostHW)/parseFloat(qtyInners) * 100) / 100).toFixed(2);
                        }
                        break;

                    case "EA":
                        if (!isNaN(caseCost) && casePackQty) {
                            wacPrice = (Math.round(parseFloat(caseCost)/parseFloat(casePackQty) * 100) / 100).toFixed(2);
                        }
                        if (!isNaN(caseCostPR) && casePackQty) {
                            wacPricePR = (Math.round(parseFloat(caseCostPR)/parseFloat(casePackQty) * 100) / 100).toFixed(2);
                        }
                        if (!isNaN(caseCostHW) && casePackQty) {
                            wacPriceHW = (Math.round(parseFloat(caseCostHW)/parseFloat(casePackQty) * 100) / 100).toFixed(2);
                        }
                        break;
                }

                $("#wac_price").val(wacPrice);
                $("#wac_price_pr").val(wacPricePR);
                $("#wac_price_hawaii").val(wacPriceHW);
            }

            // Case cost shouldn't be recalculated here. Trigger change on case_cost, not wac_price.
            $("#case_cost").trigger('change');
        }
    }).trigger("change", {initialRun: true});

    /**
     * Update the Quantity of Inners value if we can.
     * If we do, we'll also make the field read-only.
     * If we can't, we'll make it editable.
     *
     * @returns {number|string}
     */
    function updateQuantityInners() {
        const inners = $("#inners").val();
        const qtyInnersField = $("#quantity_inners");
        const casePackQtyField = $("#case_pack_quantity");
        const casePackQty = parseFloat(casePackQtyField.val());
        const innerPackQtyField = $("#inner_pack_quantity");
        const innerPackQty = parseFloat(innerPackQtyField.val());
        const qtyInners = casePackQty && innerPackQty
            // TODO It's generally best to do multiplication and division with a library like bignumber.js instead of in native JS.
            ? casePackQty / innerPackQty
            : '';

        if (casePackQty && innerPackQty) {
            qtyInnersField.closest("td").attr('class', 'readonly')
            qtyInnersField.attr("readonly", true);
        } else {
            qtyInnersField.closest("td").removeClass("readonly")
            qtyInnersField.attr("readonly", false);
        }

        const validationTag = 'quantityInners-integer-only';
        if (qtyInners > 0 && !Number.isInteger(qtyInners) && inners == 'Y') {
            let message = 'Please enter a valid number so that the calculated value for Quantity of Inners are a whole number.';
            const roundedQtyInners = Math.round(qtyInners * 100) / 100;
            message += ' Current Quantity of Inners calculated value: ' + roundedQtyInners;

            window.fieldValidate.overwriteMessageFromSameTag(casePackQtyField, message, validationTag, true);
            window.fieldValidate.overwriteMessageFromSameTag(innerPackQtyField, message, validationTag, true);
            qtyInnersField.val('');
            return roundedQtyInners;
        }

        // if (window.fieldValidate.currentMessageIsFromTag(casePackQtyField, validationTag)) {
            // console.log('clear message case: ',validationTag);
            window.fieldValidate.resetValidation(casePackQtyField);
        // }

        // if (window.fieldValidate.currentMessageIsFromTag(innerPackQtyField, validationTag)) {
            // console.log('clear message inner: ',validationTag);
            window.fieldValidate.resetValidation(innerPackQtyField);
        // }

        qtyInnersField.val(qtyInners);
        return qtyInners;
    }

    // shipping_method logic:
    // the onchange event of shipping_method affects inners, wholesale_unit, quantity_measure
    // and #tab_inner-information
    var shipping_method_select = $("#shipping_method");
    var pcode_uom_select = $("#pcode_uom");
    var pcode_uom_val = $("#pcode_uom").val();
    var inners_select = $("#inners");
    var wholesale_unit_select = $("#wholesale_unit");
    var quantity_measure_select = $("#quantity_measure");
    var po_id_select = $("#po_id");
    var pcode_identifier_select = $("#pcode_identifier");
    var inners_init = inners_select.val();
    var shipping_method = shipping_method_select.val();
    var quantity_measure = quantity_measure_select.val();
    var quantity_measure_select_title = {
        CS: "Click drop down arrow and select the Order Quantity Measure:\n- Cases\n- Dozens\n- Inners (PK)\n- Eaches",
        DZ: "Click drop down arrow and select the Order Quantity Measure:\n- Dozens\n- Inners (PK)\n- Eaches",
        PK: "Click drop down arrow and select the Order Quantity Measure:\n- Inners (PK)\n- Eaches",
        EA: "Click drop down arrow and select the Order Quantity Measure:\n- Eaches",
    };
    var quantity_measure_options = {
        // key = shipping_method
        CS: {
            "": "-select-",
            "CS": "Cases",
            "DZ": "Dozens",
            "PK": "Inners (PK)",
            "EA": "Eaches"
        },
        DZ: {
            "": "-select-",
            "DZ": "Dozens",
            "PK": "Inners (PK)",
            "EA": "Eaches"
        },
        PK: {
            "": "-select-",
            "PK": "Inners (PK)",
            "EA": "Eaches"
        },
        EA:{
            "": "-select-",
            "EA": "Eaches",
        },
        DL: {
            "": "-select-",
            "DL": "DL",
        },
    };
    var wholesale_unit_options = {
        // key = shipping_method
        CS: {
            "": "-select-",
            "CS": "Cases",
            "PK": "Inners (PK)",
            "EA": "Eaches"
        },
        DZ: {
            "": "-select-",
            "EA": "Eaches"
        },
        PK: {
            "": "-select-",
            "PK": "Inners (PK)",
            "EA": "Eaches"
        },
        EA:{
            "": "-select-",
            "EA": "Eaches",
        },
        DL: {
            "": "-select-",
            "DL": "DL",
        },
    };

    var uom_codes = {
        "EAN": "EAN",
        "GTIN": "GTIN",
        "HIBCC": "HIBC",
        "HRI": "HRI",
        "NDC": "NDC",
        "UPC": "UPC",
        "VC": "VC",
        "VB": "VB"
    };

    var po_id_options = {
        CS: {"": "-select-"},
        DZ: {"": "-select-"},
        PK: {"": "-select-"},
        EA: {"": "-select-"},
        DL: {"": "-select-"},
    };

    $.each(['CS','DZ','PK','EA','DL'], function(uom_idx,uom_val) {
        $.each(uom_codes, function(code_idx,code_val) {
            var t = uom_val+" "+code_idx;
            if (uom_val == "CS" || uom_val == "DZ" || uom_val == "PK" || uom_val == "EA") {
                po_id_options["CS"][t] = uom_val+" "+code_val;
            }
            if (uom_val == "DZ" || uom_val == "PK" || uom_val == "EA") {
                po_id_options["DZ"][t] = uom_val+" "+code_val;
            }
            if (uom_val == "PK" || uom_val == "EA") {
                po_id_options["PK"][t] = uom_val+" "+code_val;
            }
            if (uom_val == "EA") {
                po_id_options["EA"][t] = uom_val+" "+code_val;
            }
            if (uom_val == "DL") {
                if(code_val != "VC" && code_val != "VB") {
                    po_id_options["DL"][t] = uom_val+" "+code_val;
                }
            }
        });
    });

    var pcode_uom_options ;

    if($("#type").val() == 'display') {
        pcode_uom_options = { "": "-select-", DL: "Display" };
    } else {
        pcode_uom_options = {"": "-select-", CS: "Cases", DZ: "Dozens", PK: "Inners (PK)", EA: "Eaches"};
    }


    if (abcsetup.item != undefined) {
        if (abcsetup.item.shipping_method != undefined) {
            if (abcsetup.item.shipping_method !== 'DZ') {
                delete pcode_uom_options.DZ;
            }
        }
        if (abcsetup.item.shipping_method != undefined) {
            if (abcsetup.item.inners == "N") {
                delete pcode_uom_options.PK;
            }
        }

        if (abcsetup.item.pcode_uom != undefined) {
            pcode_uom_select.trigger('change');
            pcode_identifier_select.val(abcsetup.item.pcode_identifier);
            pcode_identifier_select.trigger('change');
        }
    }

    html_select_options_replace({
        select: pcode_uom_select,
        options: pcode_uom_options,
        selected: pcode_uom_val,
    });

    var p_code_options = {
        CS: {"": "-select-"},
        DZ: {"": "-select-"},
        PK: {"": "-select-"},
        EA: {"": "-select-"},
        DL: {"": "-select-"},
    };

    var uom_code_convert = {
        'CS': 'case',
        'DZ': 'dozens',
        'PK': 'pack',
        'EA': 'item',
        'DL': 'display'
    }

    var pcode_identifier_codes = ["EAN","GTIN","HIBCC","HRI","NDC10","UPC","VC","VB"];

    $.each(['CS','DZ','PK','EA','DL'], function(uom_idx,uom_val) {
        $.each(pcode_identifier_codes, function(code_idx,code_val) {
            var t = uom_val+" "+code_val;
            if(code_val !== 'VC' && code_val !== "VB") {
                p_code_options[uom_val][t] = t ;
            } else {
                var field_name = uom_code_convert[uom_val]+"_"+code_val.toLowerCase();
                if (code_val == 'VC') {
                    var vc_field = $("#"+field_name);
                    if(!vc_field.prop('disabled') && !vc_field.is(":hidden") && vc_field.length) {
                        p_code_options[uom_val][t] = t ;
                    }
                }
                if (code_val == 'VB') {
                    var vb_field = $("#"+field_name);
                    if(!vb_field.prop('disabled') && !vb_field.is(":hidden") && vb_field.length) {
                        p_code_options[uom_val][t] = t ;
                    }
                }
            }
        });
    });

    $.each(['CS','DZ','PK','EA','DL'], function(uom_idx,uom_val) {
        // append MP to each list
        po_id_options[uom_val]["MP"] = "Mfg Part #";
    });

    /*$(".article_identifier").change(function() {
        var format_code = $(this).closest("tr").find(".format_code");
        format_code.closest("span").find(".input_required_indicator").remove();
        if($(this).val().length && format_code.is(":visible")) {
           $('<span class="input_required_indicator">*</span>').insertAfter(format_code);
        }
    });

    $(".article_identifier").each(function(){
        var format_code = $(this).closest("tr").find(".format_code");
        format_code.closest("span").find(".input_required_indicator").remove();
        if($(this).val().length && format_code.is(":visible")) {
           $('<span class="input_required_indicator">*</span>').insertAfter(format_code);
        }
    });*/

    /*po_id_select.change(function() {
        var po_id_val = po_id_select.val();
        if (po_id_val == "" || po_id_val === null) {
            return;
        }
        var css_classes = ["item_product_code","case_product_code","inner_product_code","dozens_product_code"];
        for (var idx in css_classes) {
            $("."+css_classes[idx]).attr('required', false).removeClass("invalid");
            $("."+css_classes[idx]).closest("div.form-group").removeAttr("requiredIf").removeClass("required");
        }
        switch (po_id_val.substr(0,2)) {
           case "CS":
            var case_identifier;
            if (po_id_val.substr(3).toLowerCase() != 'ndc') {
                case_identifier = $("#case_"+po_id_val.substr(3).toLowerCase());
            }
            else {
                case_identifier = $("#case_"+po_id_val.substr(3).toLowerCase()+"10_format");
            }
            case_identifier.attr('required', true);
            case_identifier.closest("div.form-group").addClass("required");
            break;
           case "DZ":
            var dozens_identifier;
            if (po_id_val.substr(3).toLowerCase() != 'ndc') {
                dozens_identifier = $("#dozens_"+po_id_val.substr(3).toLowerCase());
            }
            else {
                dozens_identifier = $("#dozens_"+po_id_val.substr(3).toLowerCase()+"10_format");
            }
            dozens_identifier.attr('required', true);
            dozens_identifier.closest("div.form-group").addClass("required");
            break;
           case "PK":
            var inner_identifier;
            if (po_id_val.substr(3).toLowerCase() != 'ndc') {
                inner_identifier = $("#inner_"+po_id_val.substr(3).toLowerCase());
            }
            else {
                inner_identifier = $("#inner_"+po_id_val.substr(3).toLowerCase()+"10_format");
            }
            inner_identifier.attr('required', true);
            inner_identifier.closest("div.form-group").addClass("required");
            break;
        }
        if (po_id_val != "MP") {
           // at least one item_product_code must be provided for any value of po_Id except MP - see ticket:703
           console.log('add item identifier required back')
            $(".item_product_code").attr('required', true);
            $(".item_product_code").closest("div.form-group").addClass("required");
            $(".item_article_identifier").trigger("change");
        }
    }).trigger("change");*/

    inners_select.change(function(){
        var shipping_method = shipping_method_select.val();
        var inners_val = $(this).val();
        var wholesale_unit = '';
        var wsu_options = Object.assign({},wholesale_unit_options[shipping_method]);
        if (wholesale_unit_select.length) {
            wholesale_unit = wholesale_unit_select.val();
        }
        if (inners_val == 'N') {
            delete wsu_options.PK;
            if (wholesale_unit == 'PK'){
                wholesale_unit = '';
            }
        }
        html_select_options_replace({
            select: wholesale_unit_select,
            options: wsu_options,
            selected: wholesale_unit,
        });
    });

    shipping_method_select.change(function() {
        var shipping_method = $(this).val();
        var wholesale_unit = '';
        // var case_pack_quantity = $("#case_pack_quantity").val();
        // var inner_pack_quantity = $("#inner_pack_quantity").val();
        // var qtyInners = $("#quantity_inners").val();
        if (wholesale_unit_select.length) {
           wholesale_unit = wholesale_unit_select.val();
        }
        var quantity_measure = quantity_measure_select.val();
        var po_id = po_id_select.val();
        if (shipping_method) {
            // update wholesale_unit_select
            if (wholesale_unit_select.length) {
                html_select_options_replace({
                    select: wholesale_unit_select,
                    options: wholesale_unit_options[shipping_method],
                    selected: wholesale_unit,
                });
            }
            // update quantity_measure_select
            if (quantity_measure_select.length) {
                html_select_options_replace({
                    select: quantity_measure_select,
                    options: quantity_measure_options[shipping_method],
                    selected: quantity_measure,
                });
                quantity_measure_select.attr("title",quantity_measure_select_title[shipping_method]);
            }
            // update po_id_select
            if (po_id_select.length) {
                html_select_options_replace({
                    select: po_id_select,
                    options: po_id_options[shipping_method],
                    selected: po_id,
                });
            }
        }
        switch (shipping_method) {
            case "PK":
                // set inners_select and expose inners tab
                inners_select.val("Y").change().attr("disabled",true).addClass("readonly");
                inners_select.after('<input type="hidden" name="inners" id="inners" value="Y">');
                //tabs_inner_information.closest('li').show();
                break;
            case "CS":
            case "DZ":
            case "EA":
                // NOTE: do NOT alter the value of inners_select or visibility of #tab_inner-information
                //inners = inners_select.val();
                inners_select.attr("disabled",false).removeClass("readonly");
                $("input[name='inners']").remove(); // remove hidden input inserted above
                //inners_select.val(inners).change();
                //$("[href='#tab_inner-information']").closest('li').hide();
                var no_inner_data = true;
                $("#tab_inner-information").find("input").each(function() {
                    if ($(this).val() != "") {
                        no_inner_data = false;
                        return false;
                    }
                });
                if (no_inner_data) {
                    // if inners_init was set, then explicitly set it N, otherwise blank
                    if (inners_init) {
                        inners_select.val("N").change();
                    }
                    else {
                        inners_select.val("").change();
                    }
                }
                break;
        }

        abcsetup.front_store.form._setUomCost();
    });

    pcode_uom_select.change(function() {
        var item_iden = $(this).val();
        if(item_iden && p_code_options) {
            html_select_options_replace({
                select: pcode_identifier_select,
                options: p_code_options[item_iden],
            });
        }
    });

    pcode_identifier_select.change(function() {
        $.each(['CS','DZ','PK','EA','DL'], function(uom_idx,uom_val) {
            $.each(pcode_identifier_codes,function(code_idx,code_val) {
                var field_name = uom_code_convert[uom_val]+"_"+code_val.toLowerCase();
                if(!$("#"+field_name).closest("td").hasClass("required")) {
                    $("#"+field_name).parent().find(".pcode_identifier").remove();
                }
            });
        });

        if($(this).val()) {
            pcode = $(this).val();
            var uom_val = uom_code_convert[pcode.split(' ')[0]];
            var code_val =  pcode.split(' ')[1].toLowerCase();
            var field_name = uom_val + '_'+ code_val;
            var iden_field = $("#"+field_name);
            if(pcode) {
                window.fieldValidate.removeOrnaments(iden_field);
                iden_field.attr('required', false);
                iden_field.closest("div.form-group").removeAttr("requiredIf").removeClass("required");
                $('<span class="input_required_indicator pcode_identifier">*</span>').insertAfter("#"+field_name);
            }
        }
    });

    if (!shipping_method_select.is(':disabled')) {
        // only trigger change event if shipping_method_select is not disabled
        shipping_method_select.trigger("change");
    }

    /* DISABLED VIA GREG REQUEST ABCS-4181 */
    /* $("#third_party_marketplace").change(function() {
        if ($("#type").val() != 'otg') {
            var third_party_marketplace = $(this).val();
            var field = $('input.attachment_file[data-idx="spec_sheet"]');
            $("button[id='spec_sheet']").removeClass("btn-optional");
            if (third_party_marketplace == "N") {
                $("button[id='spec_sheet']").addClass("btn-required btn-danger required");
                field.show().attr('required', true);
            }
            else {
                $("button[id='spec_sheet']").removeClass("btn-required btn-danger required");
                field.hide().attr('required', false);
            }
        }
    }); */

    $(function() {
        if ($("#sds_waiver").length) {
            $("#sds_waiver").trigger("change");
        }
        else {
            //$("button[id='sds_waiver']").removeClass("btn-required btn-danger required").hide();
            //$("#msds_sheet").removeClass("btn-required btn-danger required").hide();
        }

        if ($("#third_party_marketplace").length) {
            $("#third_party_marketplace").trigger("change");
        }

        if (abcsetup.userRole.class == 'bluepoint_cm') {
            $("#flat_product_bar_code_image").removeClass("btn-danger required");
            $("input[data-idx='flat_product_bar_code_image']").attr('required',false);
        }

        if(abcsetup.userRole.class == 'fs_cm' && abcsetup.ruleSet != 'copy_item') {
            $("#flat_product_bar_code_image").removeClass("btn-danger required");
            $("input[data-idx='flat_product_bar_code_image']").attr('required',false);
            $("#front_panel_product_image").removeClass("btn-danger required");
            $("input[data-idx='front_panel_product_image']").attr('required',false);
        }

        if (abcsetup.userRole.class != 'bluepoint_cm') {
            $("#sap_pricing_letter").removeClass("btn-danger required").hide();
            $("input[data-idx='sap_pricing_letter']").attr('required',false);
            $("#ahp_pricing_letter").removeClass("btn-danger required").hide();
            $("input[data-idx='ahp_pricing_letter']").attr('required',false);
            $("#mwi_pricing_letter").removeClass("btn-danger required").hide();
            $("input[data-idx='mwi_pricing_letter']").attr('required',false);
        }
    });

    /*
    * CFR and IATA hazmat
    */
    $("#product_regulated_cfr").change(function() {
        if ($(this).val() == "Y") {
            // Reset the CFR fields
            $("#product_regulated_iata").val("Y").trigger("change");
            $("#product_regulated_iata").attr("disabled",true).parent("td").addClass("readonly");
            $("#product_regulated_iata").after('<input type="hidden" name="product_regulated_iata" value="Y">');
        }
        else {
            if (!$("#product_regulated_iata").hasClass("disabled")) {
                $("#product_regulated_iata").attr("disabled",false).parent("td").removeClass("readonly");
            }
            $("input[name='product_regulated_iata']").remove();
            $("#product_regulated_iata").trigger("change");
        }
    }).trigger("change");

    var hazmat_fields = {
        cfr: [
            "product_regulated",
            "un_id",
            "hazard_class",
            "pack_group",
            "shipping_name_1",
            "label_code",
            "qty_limit_par",
            "qty_limit_cao",
            "vessel_stowage_location",
            "vessel_stowage_other",
        ],
        iata: [
            "product_regulated",
            "un_id",
            "shipping_name",
            "descr",
            "pack_group",
        ],
    };
    var hazmat_types = ['cfr','iata'];
    var hazmat_config = {
        change_field: function(args) {
            // args: hazmat_type, field, data_obj
            console.log("hazmat_config.change_field: args->"+JSON.stringify(args,{},4));
            hazmat_config[args.hazmat_type][args.field+"_select"].obj.empty();
            var list_length = Object.keys(args.data_obj).length;
            if (list_length > 1) {
                hazmat_config[args.hazmat_type][args.field+"_select"].obj.append($("<option></option>").attr("value","").text("-select-"));
            }
            Object.keys(args.data_obj).forEach(function(key) {
                hazmat_config[args.hazmat_type][args.field+"_select"].obj.append($("<option></option>").attr("value",key).text(key));
            });
            if (list_length == 1) {
                hazmat_config[args.hazmat_type][args.field+"_select"].obj.trigger("change", {revalidate: true});
            }
            else {
                if (hazmat_config[args.hazmat_type][args.field+"_select"].obj.find("option[value='"+hazmat_config[args.hazmat_type][args.field+"_select"].val+"']").length) {
                    hazmat_config[args.hazmat_type][args.field+"_select"].obj.val(hazmat_config[args.hazmat_type][args.field+"_select"].val);
                    hazmat_config[args.hazmat_type][args.field+"_select"].obj.trigger("change", {revalidate: true});
                }
            }
        }
    };

    hazmat_types.forEach(function(hazmat_type) {
        hazmat_config[hazmat_type] = {};
        // field objects
        hazmat_fields[hazmat_type].forEach(function(hazmat_field) {
            hazmat_config[hazmat_type][hazmat_field+"_select"] = {};
            hazmat_config[hazmat_type][hazmat_field+"_select"]["obj"] = $("#"+hazmat_field+"_"+hazmat_type);
            hazmat_config[hazmat_type][hazmat_field+"_select"]["val"] = "_undef_";
            if (abcsetup.item != undefined) {
                if (abcsetup.item[hazmat_field+"_"+hazmat_type] != undefined) {
                    hazmat_config[hazmat_type][hazmat_field+"_select"]["val"] = abcsetup.item[hazmat_field+"_"+hazmat_type]
                }
            }
        });
    });

    // add event handlers
    var abc_hazmat_obj = {};
    var selected_hazmat_fields = {};
    hazmat_types.forEach(function(hazmat_type) {
        selected_hazmat_fields[hazmat_type] = {};
        if (!hazmat_config[hazmat_type].un_id_select.obj.is(":disabled")) {
            if (hazmat_type == "cfr") {
                console.log('hazmat event handlers: cfr', hazmat_config[hazmat_type].un_id_select.obj);
                // un_id_select -> hazard_class_select
                hazmat_config[hazmat_type].un_id_select.obj.change(function() {
                    console.log('hazmat event handlers: cfr: un_id change');
                    selected_hazmat_fields[hazmat_type]["un_id"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    $("#hazmat_id_"+hazmat_type).val("");
                    hazmat_fields[hazmat_type].forEach(function(hazmat_field) {
                        if (hazmat_field != "un_id" && hazmat_field != "product_regulated") {
                            hazmat_config[hazmat_type][hazmat_field+"_select"].obj.empty().append($("<option></option>").attr("value","").text("-select-"));
                        }
                    });
                    $.ajax({
                        type: "POST",
                        url: "/abc_item/hazmat_cfr_search",
                        cache: false,
                        dataType: 'json',
                        data: {un_id: un_id},
                        success: function(result) {
                            console.log("item/hazmat_cfr_search[hazard_class]: result->"+JSON.stringify(result,{},4));
                            if (!$.isEmptyObject(result)) {
                                abc_hazmat_obj[hazmat_type] = result;
                                hazmat_config.change_field({
                                    hazmat_type: hazmat_type,
                                    field: "hazard_class",
                                    data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"]
                                });
                            }
                        }
                    });
                });
                // hazard_class_select -> pack_group_select
                hazmat_config[hazmat_type].hazard_class_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["hazard_class"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "pack_group",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group']
                    });
                });
                // pack_group_select -> shipping_name_1_select
                hazmat_config[hazmat_type].pack_group_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["pack_group"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "shipping_name_1",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"]
                    });
                });
                // shipping_name_1_select -> label_code_select
                hazmat_config[hazmat_type].shipping_name_1_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["shipping_name_1"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "label_code",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"]
                    });
                });
                // label_code_select -> qty_limit_par_select
                hazmat_config[hazmat_type].label_code_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["label_code"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "qty_limit_par",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"]
                    });
                });
                // qty_limit_par_select -> qty_limit_cao_select
                hazmat_config[hazmat_type].qty_limit_par_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["qty_limit_par"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                    var qty_limit_par = selected_hazmat_fields[hazmat_type]["qty_limit_par"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "qty_limit_cao",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"][qty_limit_par]["qty_limit_cao"]
                    });
                });
                // qty_limit_cao_select -> vessel_stowage_location_select
                hazmat_config[hazmat_type].qty_limit_cao_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["qty_limit_cao"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                    var qty_limit_par = selected_hazmat_fields[hazmat_type]["qty_limit_par"];
                    var qty_limit_cao = selected_hazmat_fields[hazmat_type]["qty_limit_cao"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "vessel_stowage_location",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"][qty_limit_par]["qty_limit_cao"][qty_limit_cao]["vessel_stowage_location"]
                    });
                });
                // vessel_stowage_location_select -> vessel_stowage_other_select
                hazmat_config[hazmat_type].vessel_stowage_location_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["vessel_stowage_location"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                    var qty_limit_par = selected_hazmat_fields[hazmat_type]["qty_limit_par"];
                    var qty_limit_cao = selected_hazmat_fields[hazmat_type]["qty_limit_cao"];
                    var vessel_stowage_location = selected_hazmat_fields[hazmat_type]["vessel_stowage_location"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "vessel_stowage_other",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"][qty_limit_par]["qty_limit_cao"][qty_limit_cao]["vessel_stowage_location"][vessel_stowage_location]["vessel_stowage_other"]
                    });
                });
                // vessel_stowage_other_select
                hazmat_config[hazmat_type].vessel_stowage_other_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["vessel_stowage_other"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var hazard_class = selected_hazmat_fields[hazmat_type]["hazard_class"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var shipping_name_1 = selected_hazmat_fields[hazmat_type]["shipping_name_1"];
                    var label_code = selected_hazmat_fields[hazmat_type]["label_code"];
                    var qty_limit_par = selected_hazmat_fields[hazmat_type]["qty_limit_par"];
                    var qty_limit_cao = selected_hazmat_fields[hazmat_type]["qty_limit_cao"];
                    var vessel_stowage_location = selected_hazmat_fields[hazmat_type]["vessel_stowage_location"];
                    var vessel_stowage_other = selected_hazmat_fields[hazmat_type]["vessel_stowage_other"];
                    var hazmat_id = abc_hazmat_obj[hazmat_type][un_id]["hazard_class"][hazard_class]['pack_group'][pack_group]["shipping_name_1"][shipping_name_1]["label_code"][label_code]["qty_limit_par"][qty_limit_par]["qty_limit_cao"][qty_limit_cao]["vessel_stowage_location"][vessel_stowage_location]["vessel_stowage_other"][vessel_stowage_other]["hazmat_id"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    console.log("hazmat_id->"+hazmat_id);
                    $("#hazmat_id_"+hazmat_type).val(hazmat_id);
                });
                if (hazmat_config[hazmat_type].product_regulated_select.obj.val() == "Y") {
                    hazmat_config[hazmat_type].un_id_select.obj.trigger("change");
                }
            }
            else if (hazmat_type == "iata") {
                // un_id_select -> shipping_name_select
                hazmat_config[hazmat_type].un_id_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["un_id"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    $("#hazmat_id_"+hazmat_type).val("");
                    hazmat_fields[hazmat_type].forEach(function(hazmat_field) {
                        if (hazmat_field != "un_id" && hazmat_field != "product_regulated") {
                            hazmat_config[hazmat_type][hazmat_field+"_select"].obj.empty().append($("<option></option>").attr("value","").text("-select-"));
                        }
                    });
                    $.ajax({
                        type: "POST",
                        url: "/abc_item/hazmat_iata_search",
                        cache: false,
                        dataType: 'json',
                        data: {un_id: un_id},
                        success: function(result) {
                            console.log("item/hazmat_iata_search[shipping_name]: result->"+JSON.stringify(result,{},4));
                            if (!$.isEmptyObject(result)) {
                                abc_hazmat_obj[hazmat_type] = result;
                                hazmat_config.change_field({
                                    hazmat_type: hazmat_type,
                                    field: "shipping_name",
                                    data_obj: abc_hazmat_obj[hazmat_type][un_id]["shipping_name"]
                                });
                            }
                        }
                    });
                });
                // shipping_name_select -> descr_select
                hazmat_config[hazmat_type].shipping_name_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["shipping_name"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var shipping_name = selected_hazmat_fields[hazmat_type]["shipping_name"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "descr",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["shipping_name"][shipping_name]['descr']
                    });
                });
                // descr_select -> pack_group_select
                hazmat_config[hazmat_type].descr_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["descr"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var shipping_name = selected_hazmat_fields[hazmat_type]["shipping_name"];
                    var descr = selected_hazmat_fields[hazmat_type]["descr"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    hazmat_config.change_field({
                        hazmat_type: hazmat_type,
                        field: "pack_group",
                        data_obj: abc_hazmat_obj[hazmat_type][un_id]["shipping_name"][shipping_name]['descr'][descr]["pack_group"]
                    });
                });
                // pack_group_select
                hazmat_config[hazmat_type].pack_group_select.obj.change(function() {
                    selected_hazmat_fields[hazmat_type]["pack_group"] = $(this).val();
                    var un_id = selected_hazmat_fields[hazmat_type]["un_id"];
                    var shipping_name = selected_hazmat_fields[hazmat_type]["shipping_name"];
                    var descr = selected_hazmat_fields[hazmat_type]["descr"];
                    var pack_group = selected_hazmat_fields[hazmat_type]["pack_group"];
                    var hazmat_id = abc_hazmat_obj[hazmat_type][un_id]["shipping_name"][shipping_name]['descr'][descr]["pack_group"][pack_group]["hazmat_id"];
                    console.log("selected_hazmat_fields->"+JSON.stringify(selected_hazmat_fields,{},4));
                    console.log("hazmat_id->"+hazmat_id);
                    $("#hazmat_id_"+hazmat_type).val(hazmat_id);
                });
                if (hazmat_config[hazmat_type].product_regulated_select.obj.val() == "Y") {
                    hazmat_config[hazmat_type].un_id_select.obj.trigger("change");
                }
            }
        }
    });

    /**
     * Hide and show introductory allowance amount and percentage based on each other's values.
     */
     $("#intro_allowance").on("change",function() {
        if ($(this).val() != 'Y') {
            $('#allowance_perc').closest('.form-group').hide();
            $('#allowance_amount').closest('.form-group').hide();
            $('#allowance_start_date').val("");
            $('#allowance_end_date').val("");
        }
        else {
            $('#allowance_perc').closest('.form-group').show();
            $('#allowance_amount').closest('.form-group').show();
            $("#allowance_amount").trigger("change");
            $("#allowance_perc").trigger("change");
        }
    }).trigger("change");

    $('#allowance_amount').on('keyup change', function () {
        if ($(this).val()){
            $('#allowance_perc').val("");
            $('#allowance_perc').closest('.form-group').hide();
        } else {
            $('#allowance_perc').closest('.form-group').show();
        }
        // $('#allowance_perc').closest('.form-group').toggle(!this.value);
    }).trigger('change');
    $('#allowance_perc').on('keyup change', function () {
        if ($(this).val()){
            $('#allowance_amount').val("");
            $('#allowance_amount').closest('.form-group').hide();
        } else {
            $('#allowance_amount').closest('.form-group').show();
        }
        // $('#allowance_amount').closest('.form-group').toggle(!this.value);
    }).trigger('change');

    // allowance_*_date
    $("#allowance_start_date").on("change",function() {
        $("#allowance_end_date").attr( "min", $(this).val());
    });
    $("#allowance_end_date").on("change",function() {
        $("#allowance_start_date").attr( "max", $(this).val());
    });

    // avail_*_date
    $("#avail_start_date").on("change",function() {
        $("#avail_end_date").attr( "min", $(this).val());
    });
    $("#avail_end_date").on("change",function() {
        $("#avail_start_date").attr( "max", $(this).val());
    });

    // display_*_date
    $("#display_deal_start_date").on("change",function() {
        $("#display_deal_end_date").attr( "min", $(this).val());
    });
    $("#display_deal_end_date").on("change",function() {
        $("#display_deal_start_date").attr( "max", $(this).val());
    });

    $('#alcohol').on('change',function(){
        var val = $(this).val();
        if (val == 'Y') {
            var alcohol_free = $("#alcohol_free").val();
            var sel_value = "";
            if (alcohol_free != "") {
               sel_value = alcohol_free;
            }
            else {
               sel_value = "N";
            }
            $("#alcohol_free").val(sel_value).attr("disabled",true).addClass("readonly");
            $("#alcohol_free").after('<input type="hidden" name="alcohol_free" value="'+sel_value+'">');
        } else
        if (val == 'N') {
            var alcohol_free = $("#alcohol_free").val();
            var sel_value = "";
            if (alcohol_free != "") {
               sel_value = alcohol_free;
            }
            if (!$("#alcohol_free").hasClass("disabled")) {
               $("#alcohol_free").val(sel_value).attr("disabled",false).removeClass("readonly");
            }
            $("input[name='alcohol_free']").remove();
        }
    }).trigger('change');
    $('#alcohol_free').on('change',function(){
        var val = $(this).val();
        if (val == 'Y') {
            var alcohol = $("#alcohol").val();
            var sel_value = "";
            if (alcohol != "") {
               sel_value = alcohol;
            }
            else {
               sel_value = "00";
            }
            $("#alcohol").val(sel_value).attr("disabled",true).addClass("readonly");
            $("#alcohol").after('<input type="hidden" name="alcohol" value="'+sel_value+'">');
        } else
        if (val == 'N') {
            var alcohol = $("#alcohol").val();
            var sel_value = "";
            if (alcohol != "") {
               sel_value = alcohol;
            }
            if (!$("#alcohol").hasClass("disabled")) {
               $("#alcohol").val(sel_value).attr("disabled",false).removeClass("readonly");
            }
            $("input[name='alcohol']").remove();
        }
    }).trigger('change');

    $("select[name='genitemcatgroup']").change(function(){
        if($(this).val()== "ZFRE") {
            // $("input[name='nrfhg']").val("4").attr("disabled",true).addClass("readonly");
            $("input[name='nrfhg']").val("4").attr("readonly",true);
        } else {
            $("input[name='nrfhg']").val("").attr("readonly",true);
        }
    }).trigger("change");

    $("#category").on('change',function(e){
        var $category_manager_select = $("#category_manager");
        var private_label_select = $("#private_label");
        var gnp_select = $("#gnp");

        if (private_label_select.val() == "Y" || gnp_select.val() == "Y") {
            e.stopImmediatePropagation();
            updateCategoryManager($category_manager_select);
        }

        css_classes = [
            "mfg_part_num",
            "item_article_identifier",
            "inner_article_identifier",
            "case_article_identifier",
            "dozens_article_identifier"];

        if ($(this).val() == "7900") {
            css_classes.forEach(css_class => {
                $("." + css_class).addClass("ssu_identifiers");
            });
        }
        else {
            css_classes.forEach(css_class => {
                $("." + css_class).removeClass("ssu_identifiers");
            });
        }
    });

    $("#category_manager").on('change', function(e) {
        var $category_manager_select = $(this);
        var private_label_select = $("#private_label");
        var gnp_select = $("#gnp");

        if (private_label_select.val() == "Y" || gnp_select.val() == "Y") {
            e.stopImmediatePropagation();
            updateCategoryManager($category_manager_select);
        } else {
            $('.temp-submission-cm-override').remove();
        }
    });

    // Hide by default
    if ($('.food-products-other').is(':checked')) {
        $('.food-products-other-description').show();
    } else {
        $('.food-products-other-description').hide();
    }

    // Food Products other checked
    $(document).on('click', '.food-products-other', function (e) {
        if ($(this).is(':checked')) {
            $('.food-products-other-description').show();
            $('.food-products').not(this).prop('disabled', true).prop('checked', false);
        } else {
            $('.food-products-other-description').hide().val('');
            $('.food-products').prop('disabled', false);
        }
    });

    // Filter out the PO ID options based on the selected shipping method - ABCS-4981
    $(document).ready(function() {
        let originalOptions = $('#po_id').html();

        function filterPOOptions() {
            let selectedShippingMethod = $('#shipping_method').val();
            let dropShipWarehouse = $('#drop_ship_warehouse').val();
            let po_id = $('#po_id');

            po_id.html(originalOptions);

            if (dropShipWarehouse === "ZNSG") {
                // Only allow options that start with the selected shipping method
                po_id.find('option').each(function() {
                    if (!$(this).val().startsWith(selectedShippingMethod)) {
                        $(this).remove();
                    }
                });
            } else if (selectedShippingMethod !== "PK" && selectedShippingMethod !== "DZ") {
                // Remove options that start with "PK" or "DZ"
                po_id.find('option').each(function() {
                    if ($(this).val().startsWith("PK") || $(this).val().startsWith("DZ")) {
                        $(this).remove();
                    }
                });
            }
        }

        $('#shipping_method, #drop_ship_warehouse').change(filterPOOptions);
    });
});

function html_select_options_replace(args) {
    // args: select, options, selected

    if (!args.select) {
        return;
    }

    const selected = args.selected || "";
    args.select.children('option').remove();

    for (const value in args.options) {
        if (!args.options.hasOwnProperty(value)) {
            continue;
        }

        const option = $('<option/>', {value, text: args.options[value]});

        if (value && selected == value) {
            option.attr('selected', true);
        }

        option.appendTo(args.select);
    }
}

// Override the category manager to Audrey McCarthy for any private label or GNP private label items per ABCS-5003
function updateCategoryManager($categoryManagerSelect) {
    $('.temp-submission-cm-override').remove();

    const newCategoryManagerValue = '6091';
    const newCategoryManagerDisplayText = 'Category Manager - Audrey McCarthy';

    if ($categoryManagerSelect.val() === newCategoryManagerValue) {
        return;
    }

    $categoryManagerSelect.prop("disabled", false);
    $categoryManagerSelect.removeAttr("readonly");

    if ($categoryManagerSelect.find("option[value='" + newCategoryManagerValue + "']").length === 0) {
        var $newOption = $("<option></option>")
                            .val(newCategoryManagerValue)
                            .text(newCategoryManagerDisplayText);
        $categoryManagerSelect.append($newOption);
    }

    $categoryManagerSelect.val(newCategoryManagerValue);
    $categoryManagerSelect.trigger('change');
    $categoryManagerSelect.addClass('readonly').attr('disabled', true);
    $categoryManagerSelect.after('<input type="hidden" class="temp-submission-cm-override" name="' + $categoryManagerSelect.attr('name') + '" value="' + newCategoryManagerValue + '">');
}

class ArticleIdentifiers {
    constructor() {
        this._group_css_classes = ['item_article_identifier', 'inner_article_identifier', 'case_article_identifier', 'dozens_article_identifier', 'display_article_identifier'];
        this.shipping_method_map = {
            EA: 'item_article_identifier',
            CS: 'case_article_identifier',
            PK: 'inner_article_identifier',
            DZ: 'dozens_article_identifier',
            DL: 'display_article_identifier',
        };
    }

    /**
     * Bind the onChange handler for these fields.
     * This is used to update which fields are marked as required.
     *
     * @returns {ArticleIdentifiers}
     */
    bindChange() {
        const _this = this;

        if ($("#category").val() != '7900') {
            $(".item_article_identifier, .inner_article_identifier, .case_article_identifier, .dozens_article_identifier, .display_article_identifier").on('change', function() {
                const this_css_class = _this._group_css_classes.find(group_css_class => $(this).hasClass(group_css_class));
                _this._updateRequiredAnnotations(this_css_class);
            }).trigger('change', {initialRun: true});
        }
        else {
            $(".ssu_identifiers").on('change', function() {
                _this._updateRequiredAnnotations("ssu_identifiers");
            }).trigger('change', {initialRun: true});
        }

        return this;
    }

    /**
     * When the shipping method changes, update which group of fields should be required.
     *
     * @returns {ArticleIdentifiers}
     */
    bindToShippingMethodChanges() {
        $('#shipping_method').on('change', () => {
            this._group_css_classes.forEach(group_css_class => {
                $(`.${group_css_class}`).each(function () {
                    // This has some knowledge of how the article identifier validation works.
                    // That is, if a field has a value, it won't have a message on it.
                    // So, no value, means this is likely either an "at-least-one" validation issue or a required validation issue, and we can therefore clear the validation.
                    !$(this).val() && window.fieldValidate.resetValidation(this);
                });

                this._updateRequiredAnnotations(group_css_class);
            });
        });

        return this;
    }

    /**
     * When the PO Identifier field changes, we need to set the associated identifier field as required.
     *
     * @returns {ArticleIdentifiers}
     */
    bindToPoIdentifierChanges() {
        const po_id_select = $('#po_id');
        const css_classes = ['item_product_code', 'case_product_code', 'inner_product_code', 'dozens_product_code', 'display_product_code'];
        const css_article_map = {
            item_product_code: 'item_article_identifier',
            case_product_code: 'case_article_identifier',
            inner_product_code: 'inner_article_identifier',
            dozens_product_code: 'dozens_article_identifier',
            display_product_code: 'display_article_identifier',
        };

        if ($("#category").val() != '7900') {
            const resetRequired = () => {
                for (const css_class of css_classes) {
                    const articleIdentifierFields = $('.' + css_class);

                    window.fieldValidate.removeOrnaments(articleIdentifierFields);
                    articleIdentifierFields.attr('required', false);

                    if (!this._shouldMarkAsRequired(css_article_map[css_class])) {
                        this._removeRequiredAnnotation(articleIdentifierFields)
                    }
                }
            }

            po_id_select.on('change', () => {
                const po_id_val = po_id_select.val();
                const group_abbreviation = po_id_val.substr(0, 2);
                const type = po_id_val.substr(3).toLowerCase();

                if (!po_id_val) {
                    return;
                }

                resetRequired();

                const identifierIDSuffix = type === 'ndc' ? type + '10_format' : type;
                switch (group_abbreviation) {
                    case 'CS':
                        this._makeRequired($('#case_' + identifierIDSuffix));
                        break;

                    case 'DZ':
                        this._makeRequired($('#dozens_' + identifierIDSuffix));
                        break;

                    case 'PK':
                        this._makeRequired($('#inner_' + identifierIDSuffix));
                        break;

                    case 'EA':
                        this._makeRequired($('#item_' + identifierIDSuffix));
                        break;

                    case 'DL':
                        this._makeRequired($('#display_' + identifierIDSuffix));
                        break;
                }

                if (po_id_val !== 'MP') {
                    // at least one item_product_code must be provided for any value of po_Id except MP - see ticket:703
                    this._updateRequiredAnnotations('item_article_identifier');
                }
            }).trigger('change', {initialRun: true});
        }

        return this;
    }

    _makeRequired(field) {
        $(field).attr('required', true);
        this._addRequiredAnnotation(field);

    }

    _addRequiredAnnotation(field) {
        $(field).closest("div.form-group").addClass("required");
    }

    _removeRequiredAnnotation(field) {
        // TODO: Should we be removing requiredIf here?
        $(field).closest('div.form-group').removeAttr('requiredIf').removeClass('required');
    }

    /**
     * Should the fields in the given group always be marked as required?
     *
     * @param {string} group_css_class
     * @returns {boolean}
     * @private
     */
    _alwaysMarkAsRequired(group_css_class) {
        if ($("#category").val() != '7900') {
            return ['item_article_identifier'].includes(group_css_class);
        }
        else {
            return false;
        }
    }

    /**
     * Should the fields in the given group be marked as required?
     *
     * @param group_css_class
     * @returns {boolean}
     * @private
     */
    _shouldMarkAsRequired(group_css_class) {
        const ship_method = {
            'item_article_identifier': 'EA',
            'inner_article_identifier': 'PK',
            'case_article_identifier': 'CS',
            'dozens_article_identifier': 'DZ',
            'display_article_identifier': 'DL'
        };

        return this._alwaysMarkAsRequired(group_css_class) || $('#shipping_method').val() === ship_method[group_css_class];

    }

    /**
     * Update the given identifier group's required annotations to match what the article identifier rule would say
     * and what the PO Identifier's value necessitates.
     *
     * @param group_css_class
     * @private
     */
    _updateRequiredAnnotations(group_css_class) {
        const _this = this;
        const articleIdentifierFields = $('.' + group_css_class);

        if (this._shouldMarkAsRequired(group_css_class)) {
            const at_least_one = articleIdentifierFields.toArray().some(elem => Boolean($(elem).val()));

            articleIdentifierFields.each(function() {
                if (at_least_one) {
                    _this._removeRequiredAnnotation(this);
                } else {
                    _this._addRequiredAnnotation(this);
                }
            });
        } else if (!this._alwaysMarkAsRequired(group_css_class)) {
            articleIdentifierFields.each(function () {
                _this._removeRequiredAnnotation(this);
            });
        }

        articleIdentifierFields.filter('[required]').each(function () {
            _this._addRequiredAnnotation(this);
        });
    }
}
